import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService, PaginatedResponse, Response } from '@tcc-mono/shared/data-access';
import { Animal } from '@tcc-mono/vandijk/shared/data-access/models';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MobileTransportGroupAnimalService extends BaseService<Animal> {
  constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/mobile/transport_groups'
  }

  public getAnimals = (transportGroupId: string | number, params?: Params): Observable<Animal[]> => {
    return this.getChild<PaginatedResponse<Animal>>(transportGroupId, 'animals', params)
      .pipe(
        map(({ data }) => data)
      );
  }

  public getAnimal = (transportGroupId: PropertyKey, animalId: PropertyKey): Observable<Animal> => {
    return this.getChild<Response<Animal>>(transportGroupId.toString(), `animals/${animalId.toString()}`)
      .pipe(
        map(({ data }) => data)
      );
  }

  public transferAnimal = (transportGroupId: PropertyKey, animal_id: PropertyKey, override: boolean = false): Observable<unknown> => {
    return this.postChild(
      { animal_id: animal_id.toString() },
      `${transportGroupId.toString()}/transfer_animal`,
      override ? { override } : null
    );
  }

  public addAnimal = (transportGroupId: PropertyKey, animalId: PropertyKey, override: boolean = false): Observable<unknown> => {
    return this.postChild(
      { animal_id: animalId.toString() },
      `${transportGroupId.toString()}/animals`,
      override ? { override } : null
    );
  }

  public deleteAnimal = (transportGroupId: PropertyKey, animalId: PropertyKey): Observable<Animal> => {
    return this.delete(transportGroupId.toString(), `animals/${animalId.toString()}`);
  };
}
